var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6467_5002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7242 12.9033C10.6182 12.8926 10.491 12.8926 10.3744 12.9033C7.85128 12.8184 5.84766 10.7512 5.84766 8.20693C5.84766 5.60964 7.94669 3.5 10.5546 3.5C13.1519 3.5 15.2615 5.60964 15.2615 8.20693C15.2509 10.7512 13.2473 12.8184 10.7242 12.9033Z",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4113 5.62109C20.4679 5.62109 22.1217 7.28548 22.1217 9.33151C22.1217 11.3351 20.5315 12.9677 18.5491 13.0419C18.4643 13.0313 18.3688 13.0313 18.2734 13.0419",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42412 16.8139C2.85863 18.5313 2.85863 21.33 5.42412 23.0368C8.33944 24.9874 13.1206 24.9874 16.0359 23.0368C18.6014 21.3194 18.6014 18.5207 16.0359 16.8139C13.1312 14.8739 8.35004 14.8739 5.42412 16.8139Z",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4531 22.5824C21.2164 22.4234 21.9373 22.1159 22.531 21.6601C24.1847 20.4197 24.1847 18.3737 22.531 17.1334C21.9479 16.6881 21.2376 16.3913 20.4849 16.2217",
    stroke: "#ABABC2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6467_5002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.f224cdf2f76430abdc7fd2d9daa28d57.svg";
export { ForwardRef as ReactComponent };